<template>
  <div style='width: 100%;'>

    <el-main>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('field.detector')" name="detector">
          <el-row :gutter="10">
            <el-col :span="12">
              <AddItem2List id='detector1' :title="detector.title1" :type="detector.type1" :custId="custId"  @updateSelected="syncParent"/>
            </el-col>
            <el-col :span="12">
              <AddItem2List id='detector2' :title="detector.title2" :type="detector.type2" :custId="custId"  @updateSelected="syncParent" />
            </el-col>
          </el-row>   
        </el-tab-pane>
        <el-tab-pane :label="$t('field.accessory')" name="accessory">
          <el-row :gutter="10">
            <el-col :span="12">
              <AddItem2List id='accessory1' :title="accessory.title1" :type="accessory.type1" :custId="custId" @updateSelected="syncParent"/>
            </el-col>
            <el-col :span="12">
              <AddItem2List id='accessory2' :title="accessory.title2" :type="accessory.type2" :custId="custId" @updateSelected="syncParent"/>
            </el-col>
          </el-row>   
        </el-tab-pane>
        <el-tab-pane :label="$t('field.software')" name="software">
          <el-row :gutter="10">
            <el-col :span="12">
              <AddItem2List id='software1' :title="software.title1" :type="software.type1" :custId="custId" @updateSelected="syncParent"/>
            </el-col>
            <el-col :span="12">
              <AddItem2List id='software2' :title="software.title2" :type="software.type2" :custId="custId" @updateSelected="syncParent"/>
            </el-col>
          </el-row>   
        </el-tab-pane>
        <el-tab-pane :label="$t('field.semiFinishedProduct')" name="semi">
          <el-row :gutter="10">
            <el-col :span="12">
              <AddItem2List id='semi1' :title="semi.title1" :type="semi.type1" :custId="custId" @updateSelected="syncParent"/>
            </el-col>
            <el-col :span="12">
              <AddItem2List id='semi2' :title="semi.title2" :type="semi.type2" :custId="custId" @updateSelected="syncParent"/>
            </el-col>
          </el-row>   
        </el-tab-pane>
        <el-tab-pane :label="$t('field.document')" name="document">
          <el-row :gutter="10">
            <el-col :span="12">
              <AddItem2List id='document1' :title="document.title1" :type="document.type1" :custId="custId" @updateSelected="syncParent"/>
            </el-col>            
          </el-row>   
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
import AddItem2List from './AddItem2List'


export default {
  name: 'productInfo',
  props: {    
    custId: {
        type: String
    }   
  },
  data() {   
    return {   
      activeName: 'detector',
      detector:{
        title1: this.$i18n.t('field.innocareModel'),
        title2: this.$i18n.t('field.odmModel'),
        type1:'DETECTOR_INNOCARE_MODEL',
        type2:'DETECTOR_ODM_MODEL',
        selectedLlist1:[],
        selectedLlist2:[]     
      },
      accessory:{
        title1:this.$i18n.t('field.innocareModel'),
        title2:this.$i18n.t('field.odmModel'),
        type1:'ACCESSORY_INNOCARE_MODEL',
        type2:'ACCESSORY_ODM_MODEL',
        selectedLlist1:[],
        selectedLlist2:[]         
      },
      software:{
        title1: this.$i18n.t('field.innocareSoftware'),
        title2: this.$i18n.t('field.fujifilmSoftware'),
        type1:'SOFTWARE_INNOCARE',
        type2:'SOFTWARE_ODM',
        selectedLlist1:[],
        selectedLlist2:[]     
      },
      semi:{
        title1: this.$i18n.t('field.oemModelCustomerType'),
        title2: this.$i18n.t('field.oemModelIncxType'),
        type1:'SEMI_CUSTOMER_MODEL',
        type2:'SEMI_INCX_MODEL' ,
        selectedLlist1:[],
        selectedLlist2:[]         
      },
      document:{
        title1: this.$i18n.t('field.docAuth'),        
        type1:'DOCUMENT_AUTH',       
        selectedLlist1:[]  
      }
    };
  }, 
  mounted() {

  },
  components: {
    AddItem2List
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    syncParent(value, type){
   
      if(type == 'DETECTOR_INNOCARE_MODEL'){
        this.detector.selectedLlist1 = value;

      }else if(type == 'DETECTOR_ODM_MODEL'){
        this.detector.selectedLlist2 = value;    

      }else if(type == 'ACCESSORY_INNOCARE_MODEL'){
        this.accessory.selectedLlist1 = value;   

      }else if(type == 'ACCESSORY_ODM_MODEL'){
        this.accessory.selectedLlist2 = value;   

      }else if(type == 'SOFTWARE_INNOCARE'){
        this.software.selectedLlist1 = value;   

      }else if(type == 'SOFTWARE_ODM'){
        this.software.selectedLlist2 = value;   

      }else if(type == 'SEMI_CUSTOMER_MODEL'){
        this.semi.selectedLlist1 = value;   

      }else if(type == 'SEMI_INCX_MODEL' ){
        this.semi.selectedLlist2 = value;   

      }else if(type == 'DOCUMENT_AUTH'){
        this.document.selectedLlist1 = value;
      }    
    }
    
  }
};
</script>
